import { Loader, ModalParts } from 'BreetComponents';
import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useUsdWithdrawRequestContext } from 'BreetHooks';
import { selectSaveWalletAddresses, useAppSelector, useGetSavedWalletAddressesQuery } from 'BreetRedux';
import { type FC, useEffect } from 'react';

import { type USDWITHDRAWREQUESTSTAGETYPE } from '../../DialogWithdrawRequest.helpers';
import { Form } from './components/form/Form';
import SendCryptoTransactionDetails from './components/SendCryptoTransactionDetails';
import {
	DialogWithdrawUsdAddWalletAddress,
	DialogWithdrawUsdScanWalletAddress,
	DialogWithdrawUsdWalletAddressesManage,
	DialogWithdrawUsdWalletAddressesSaved,
} from './components/walletAddresses';

const UsdWithdrawRequest = () => {
	const { isFetching: isFetchingSavedWalletAddress } = useGetSavedWalletAddressesQuery(undefined, alwaysRefetchApiQueryOptions);

	const { isSuccess } = useAppSelector(selectSaveWalletAddresses);

	const { formStage, formDataContextProps } = useUsdWithdrawRequestContext();

	const stageComponents: Record<USDWITHDRAWREQUESTSTAGETYPE, FC> = {
		'withdraw-funds': Form,
		'add-wallet-address': DialogWithdrawUsdAddWalletAddress,
		'saved-wallet-address': DialogWithdrawUsdWalletAddressesSaved,
		'manage-wallet-address': DialogWithdrawUsdWalletAddressesManage,
		'scan-wallet-address': DialogWithdrawUsdScanWalletAddress,
		'crypto-transaction-details': SendCryptoTransactionDetails,
	};

	useEffect(() => {
		if (isSuccess) {
			formStage.navigator.goTo('withdraw-funds')();
			formDataContextProps.hookFormProps.trigger().catch(console.error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess]);

	return (
		<>
			{isFetchingSavedWalletAddress ? (
				<Loader />
			) : (
				<>
					{Object.entries(stageComponents).map(([stage, Component]) => (
						<ModalParts.Stage
							hide={!formStage.isStageActive(stage as USDWITHDRAWREQUESTSTAGETYPE)}
							key={stage}
						>
							<Component />
						</ModalParts.Stage>
					))}
				</>
			)}
		</>
	);
};

export default UsdWithdrawRequest;
